export default __webpack_public_path__ + "static/media/mark.b65a052f.jpg";